module.exports = __webpack_public_path__ + "img/01.9de53ca0.jpg";